export const LISTING_RESPONSIBLE_MANAGER_FIELD_NAME = 'responsible_user'

export const LISTING_RESPONSIBLE_MANAGER_PAYLOAD_FIELD_NAME =
  'responsible_manager_id'

export const QA_NAME_LISTING_RESPONSIBLE_MANAGER_MODAL =
  'listingResponsibleManagerModal'

export const QA_NAME_LISTING_RESPONSIBLE_MANAGER_SELECT =
  'listingResponsibleManagerSelect'
